import React from 'react';

export const PageContextInitial = {
  title: '',
  setTitle: (title) => {},
};

export const PageContext = React.createContext(PageContextInitial);
